import { Alert, Button, Inline } from "@evolua/ui";
import { useEffect, useState } from "react";
import { track } from "../telemetry/product-events.js";

type BeforeInstallPromptEvent = Event & {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: "accepted" | "dismissed" }>;
};

const DISMISS_KEY = "evolua.pwa.install-dismissed";

export function InstallPrompt() {
  const [deferred, setDeferred] = useState<BeforeInstallPromptEvent | null>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem(DISMISS_KEY) === "1") return;
    const onBip = (e: Event) => {
      e.preventDefault();
      setDeferred(e as BeforeInstallPromptEvent);
      setVisible(true);
      track("pwa.install_prompted");
    };
    window.addEventListener("beforeinstallprompt", onBip);
    return () => window.removeEventListener("beforeinstallprompt", onBip);
  }, []);

  if (!visible || !deferred) return null;

  return (
    <div className="evolua-pwa-install">
      <Alert tone="info" title="Instalar o app">
        <Inline justify="between" gap={2}>
          <span>Instale o Evolua HCM na tela inicial para acesso rápido.</span>
          <Inline gap={2}>
            <Button
              type="button"
              size="sm"
              variant="ghost"
              onClick={() => {
                sessionStorage.setItem(DISMISS_KEY, "1");
                setVisible(false);
              }}
            >
              Agora não
            </Button>
            <Button
              type="button"
              size="sm"
              onClick={() => {
                void (async () => {
                  await deferred.prompt();
                  const choice = await deferred.userChoice;
                  if (choice.outcome === "accepted") {
                    track("pwa.installed");
                  }
                  setVisible(false);
                  setDeferred(null);
                })();
              }}
            >
              Instalar
            </Button>
          </Inline>
        </Inline>
      </Alert>
    </div>
  );
}
